/**
 * Display helpers for facility/location cleaning standards (labels, badges).
 * Pure functions for reuse and testability (Clean Code, SRP).
 */

/** Format API value to display label (e.g. "super-heavy" → "Super Heavy"). */
export function formatLevelText(level) {
  if (level == null || level === '') return '';
  return String(level)
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/** Badge class when a standard is set (consistent across Soil Load, Water Changes, Shifts). */
export const STANDARD_SET_BADGE_CLASS =
  'px-3 py-1.5 rounded-full font-[\'Roboto:Medium\',sans-serif] text-[13px] bg-[#61b8e7]/10 text-[#61b8e7] border border-[#61b8e7]/30';

/** Badge class when a standard is not set. */
export const STANDARD_NOT_SET_BADGE_CLASS =
  'px-3 py-1.5 rounded-full bg-amber-50 text-amber-700 border border-amber-300 font-[\'Roboto:Medium\',sans-serif] text-[13px]';
